import * as React from 'react'

function SvgIconSolidarity(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="solidarity" aria-labelledby="t-solidarity d-solidarity">
        <title id="t-solidarity">{'Solidarity'}</title>
        <desc id="d-solidarity">{'An awareness ribbon'}</desc>
        <path d="M19.6 18.6c2.5-3.1 4.4-5.9 4.4-7.6v-.5l-2.1-6.7C21.2 1.6 18.8 0 16 0s-5.2 1.6-5.8 3.8L8 10.5v.5c0 1.7 1.9 4.5 4.4 7.6C8.5 22.7 5 26 5 26l2 6s4.6-4.3 9-9.2c4.4 4.9 9 9.2 9 9.2l2-6s-3.5-3.3-7.4-7.4zM11.1 4.1C11.7 2.3 13.7 1 16 1s4.3 1.3 4.9 3.1c0 .1.3 1 .699 2.1C20 5.5 18.1 5 16 5s-4 .5-5.6 1.3c.4-1.2.7-2.1.7-2.2zm10.2 3.2c-1 2-3 4.7-5.3 7.3-2.3-2.6-4.3-5.3-5.3-7.3C12.1 6.5 14 6 16 6s3.9.5 5.3 1.3zM9 11c0-.2 0-.5.1-.7l.8-2.5c1.1 2.2 3.2 4.8 5.4 7.5-.8.9-1.5 1.7-2.3 2.5-2.3-2.9-4-5.5-4-6.8zM7.5 30.2l-1.3-3.9C8.8 23.8 19 13.9 22.1 7.9l.801 2.5c.099.1.099.4.099.6 0 3.1-9.1 13-15.5 19.2zm17 0c-2.5-2.4-5.3-5.3-7.9-8.101.8-.899 1.6-1.799 2.3-2.699 2.9 3.1 5.7 5.8 6.9 6.9l-1.3 3.9z" />
      </g>
    </svg>
  )
}

export default SvgIconSolidarity
